import { LANGUAGES } from 'store/LanguageProvider/constants';

export const translate = (message: any, props: any, values?: any): string =>
  props.intl.formatMessage({ ...message }, values);

export const isReverse = (lang: string) =>
  lang === LANGUAGES.AR ? true : false;
